import { render, staticRenderFns } from "./MainPrivacyPolicy.vue?vue&type=template&id=50d57e57&"
import script from "./MainPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./MainPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d57e57')) {
      api.createRecord('50d57e57', component.options)
    } else {
      api.reload('50d57e57', component.options)
    }
    module.hot.accept("./MainPrivacyPolicy.vue?vue&type=template&id=50d57e57&", function () {
      api.rerender('50d57e57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainPrivacyPolicy.vue"
export default component.exports